module.exports = __webpack_public_path__ + "static/media/fly0259.ed616168.webp";